var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shu-lan',{attrs:{"product-mark":47}})
}
var staticRenderFns = []

export { render, staticRenderFns }